// #region Imports
import React, { useMemo, useState } from 'react';

import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { appColors } from '../../../../AppTheme';
import LGPD from '../../../../consts/text/lgpd';
import FIELDS from '../../../../library/acesso-dados-fields';
import { genFieldNameAndError } from '../../../../library/utils';
import { useStyles } from '../styles';

// #endregion

const { INFO_MEIO } = LGPD;

function MeioInfoFields({
  disabled = false,
  register,
  errors,
  isTelaConsulta,
}) {
  const styles = useStyles();
  const [meioInfo, setMeioInfo] = useState('email');

  const handleRadioChange = (event) => {
    setMeioInfo(event.target.value);
  };

  const fieldProps = useMemo(
    () =>
      meioInfo === 'email'
        ? {
            placeholder: INFO_MEIO.EMAIL.PLACEHOLDER,
            className: styles.field,
            ...register(FIELDS.EMAIL),
            ...genFieldNameAndError(errors, FIELDS.EMAIL),
          }
        : {
            multiline: true,
            rows: 4,
            placeholder: INFO_MEIO.CORRESPONDENCIA.PLACEHOLDER,
            className: styles.fieldBox,
            ...register(FIELDS.CORRENSPONDENCIA),
            ...genFieldNameAndError(errors, FIELDS.CORRENSPONDENCIA),
          },
    [meioInfo, errors, styles.field, styles.fieldBox],
  );

  return (
    <>
      <Box color={appColors.gray} marginTop="20px" paddingY="10px">
        <Typography variant="subtitle1">
          {isTelaConsulta ? INFO_MEIO.CONSULTA_MEIO : INFO_MEIO.OUTRAS_MEIO}
        </Typography>
      </Box>
      <FormGroup row>
        <FormControl component="fieldset">
          <RadioGroup row value={meioInfo} onChange={handleRadioChange}>
            <FormControlLabel
              value="email"
              control={<Radio color="primary" disabled={disabled} />}
              label={INFO_MEIO.EMAIL.THIS}
              labelPlacement="end"
            />
            <FormControlLabel
              value="correspondencia"
              control={<Radio color="primary" disabled={disabled} />}
              label={INFO_MEIO.CORRESPONDENCIA.THIS}
              labelPlacement="end"
            />
          </RadioGroup>
        </FormControl>
      </FormGroup>
      <FormGroup row>
        <TextField
          disabled={disabled}
          variant="outlined"
          InputProps={{
            inputProps: {
              'data-testid': fieldProps?.name,
            },
          }}
          {...fieldProps}
        />
      </FormGroup>
    </>
  );
}

export default MeioInfoFields;
